/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
export default {
  components: {
    VPagination,

  },
  data() {
    return {
      signerslist: [],
      baseurl: process.env.VUE_APP_Service_URL,
      envelopestatus:"",
      envolopid:"",
      iframeurl:"",
      showLoading:false,
      signingUrl:false,
      selectedenvelopid:"",
      selectedsignorder:"",
      selectedrecepientemal:"",
      testiframe:false,
      currentPage: 1,
      pageindex: 1,
      pagesize: 10,
      totalPage: 1,
      SortProperty: "",
      SortOrder: false,
      isSigningUrlFetching: false, // fetching the signing URL via API
      isIframeLoading: false,      // the iframe content is loading
      SortOrderInt: 1,
        searchField: {
        documentTitle: "",
        status: "",
        createdAt: "",
      },
      datacorrected:{
        "sent":"Pending",
        "created":"Awaiting",
        "completed":"Signed",
        

      }
    };
  },
  unmounted() {
    delete window.showAlert;
  },
  async mounted() {
    window.showAlert = this.showAlert.bind(this);
    window.addEventListener("studyIdChanged", (event) => {
      this.Getsignerslist();
    }
    );
    this.Getsignerslist();
  },
  methods: {
    async testingiframe(){
this.testiframe = true;
    },
    async viewDocumentDetails(id, name) {
      this.$router.push(`/documentview/${name}/1`)
    },
    async showAlert(message) {
      this.signingUrl = false;
      console.log(message);
     const idtoken = store.getters.getIdToken;
     console.log("idtocken", idtoken);
     
     await axios
        .post(`${this.baseurl}/etmf/docusign/activatenextsigner?envelopeId=${this.selectedenvelopid}&signOrder=${this.selectedsignorder}&recipientEmail=${this.selectedrecepientemal}`,
          {}, 
          {
            
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.Getsignerslist();
        })
        .catch((err) => {
          console.error(err)
        });
     
  },
async getiframeapi(envelopeId, recipientEmail, recipientSignOrder) {
  this.selectedrecepientemal = recipientEmail;
  this.selectedsignorder = recipientSignOrder;
  this.selectedenvelopid = envelopeId;

  const idtoken = store.getters.getIdToken;

  // Start the "preparing" loader
  this.isSigningUrlFetching = true;
  this.signingUrl = false;      // hide iframe area until we have a URL
  this.iframeurl = "";          // clear old URL if any

  try {
    const res = await axios.get(
      `${this.baseurl}/etmf/docusign/getsigningurl?envelopeId=${envelopeId}&recipientEmail=${recipientEmail}`,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    );

    // Show the iframe area
    this.signingUrl = true;

    // Now the iframe will begin loading → show iframe loader
    this.isIframeLoading = true;
    this.iframeurl = res.data.signingUrl; // setting src triggers the iframe load

  } catch (err) {
    console.log("No data found!", err);
    this.signingUrl = false; // keep the list view if it failed
  } finally {
    // Done fetching the URL itself
    this.isSigningUrlFetching = false;
  }
},

onIframeLoad() {
  // Iframe fully loaded → hide iframe loader
  this.isIframeLoading = false;
},
    loadsignerslist: function (page) {
      this.currentPage = page;
      this.Getsignerslist();
    },
    async Getsignerslist() {
      const idtoken = store.getters.getIdToken;
      let studyid = store.getters.getStudyIs;
      this.showLoading=true
      await axios
        .get(
          `${this.baseurl}/etmf/docusign/getsignerdocuments?studyId=${studyid}&pageindex=${this.currentPage}&pagesize=10&sortProperty=${this.SortProperty}&sortOrder=${this.SortOrderInt}&documentTitle=${this.searchField.documentTitle}&recStatus=${this.searchField.status}&createdAt=${this.searchField.createdAt}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.signerslist = res.data.entities;
          console.log("this.signerslist",this.signerslist);
          this.totalPages = Math.max(1, Math.ceil(Number(res.data.totalCount) / 10));
           this.showLoading=false

        })
        .catch((err) => {

           this.showLoading=false
          this.userList = []
          console.log("No data found in!", err)

        })
    },
    async searchDocuments() {
      this.currentPage = 1;
      this.Getsignerslist();
    },
       SortSelected(sortProp) {
      if (this.SortProperty === sortProp) {
        // Same column clicked → toggle sort direction
        this.SortOrder = !this.SortOrder;
      } else {
        // New column clicked → reset to ascending
        this.SortProperty = sortProp;
        this.SortOrder = true;
      }

      this.SortOrderInt = this.SortOrder ? 0 : 1;
      this.pageindex = 1;
      this.currentPage = 1;

      this.Getsignerslist();
    },

  },
};


